module.exports = __webpack_public_path__ + "img/13_35.5ac9795b.png";